import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const Careers = () => <PublicStaticPage pageKey="careers" />;

export default Careers;
